import { Controller } from 'stimulus';
import axios from 'axios';
import Choices from 'choices.js';

export default class extends Controller {
  static targets = ['prefectureSelect', 'lineSelect', 'stationSelect'];

  connect() {
    const choicesOptions = {
      shouldSort: false,
      itemSelectText: '',
      searchResultLimit: 50,
    };

    this.lineChoices = new Choices(this.lineSelectTarget, choicesOptions);
    this.stationChoices = new Choices(this.stationSelectTarget, choicesOptions);
  }

  prefectureChange(e) {
    axios
      .get(this.data.get('lines-url'), {
        params: { prefecture_id: e.target.value },
      })
      .then(res => {
        const items = [];
        res.data.forEach(line => {
          items.push({ value: String(line.id), label: line.text });
        });
        this.lineChoices.clearStore();
        items[0].selected = true;
        this.lineChoices.setChoices(items, 'value', 'label', true);
      });
  }

  lineChange() {
    axios
      .get(this.data.get('stations-url'), {
        params: {
          prefecture_id: this.prefectureSelectTarget.value,
          line_id: this.lineSelectTarget.value,
        },
      })
      .then(res => {
        const items = [];
        res.data.forEach(station => {
          items.push({ value: String(station.id), label: station.text });
        });
        this.stationChoices.clearStore();
        items[0].selected = true;
        this.stationChoices.setChoices(items, 'value', 'label', true);
      });
  }
}
